import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
} from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { RbChatbotComponent } from '../rb-chatbot/rb-chatbot.component';
import {
  ResizeEvent,
  ResizableDirective,
  ResizeHandleDirective,
} from 'angular-resizable-element';

@Component({
  selector: 'app-chat-panel',
  imports: [
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    RbChatbotComponent,
    ResizableDirective,
    ResizeHandleDirective,
  ],
  templateUrl: './chat-panel.component.html',
  styleUrl: './chat-panel.component.scss',
})
export class ChatPanelComponent implements OnChanges {
  open = signal(false);
  @Input() panelOpen = false;
  @Output() emitPanelOpen = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (
      Object.prototype.hasOwnProperty.call(changes, 'panelOpen') &&
      changes['panelOpen'].currentValue === true
    ) {
      this.open.update(v => true);
    }
  }

  toggle() {
    this.open.update(v => !v);
    if (this.open() === false) {
      this.emitPanelOpen.emit(false);
    }
  }

  sidenavStyle: Record<string, string> = {};

  onResizeEnd(ev: ResizeEvent) {
    if (ev.rectangle.width) {
      this.sidenavStyle = { width: `max(20vw, ${ev.rectangle.width}px)` };
    }
  }
}
